module.exports = __webpack_public_path__ + "img/logo_lx.2c682c5c.png";